module.exports = __webpack_public_path__ + "0587752a684ee6d46abe7305f635cfd6.svg";